import CountUp from 'react-countup';
const Counter = ({count , title, suffix }) => {
    return ( 
        <div className={ ` transition-shadow duration-700  flex flex-col items-center justify-center  2xl:text-5xl     text-center  2xl:my-3 2xl:px-5 md:p-4 xs:p-2 w-full    2xl:h-96 md:h-96 xs:h-96  xs:m-2   `} >
            <div className={ `2xl:text-5xl md:text-4xl xs:text-3xl p-5    font-bold text-slate-50`} >{title}</div>
            <CountUp  className='2xl:m-5  md:m-1 md:text-5xl xs:text-3xl  ' end={count} duration={5} suffix={suffix} />
        </div>
     );
}
export default Counter;